import * as vendorsServices from './vendorsServices';

export { vendorsServices };
